import ThemeFeature from "./themeFeature";

class Tooltip extends ThemeFeature {
    /**
     * Tooltips
     * @param {string} selector
     */
    enable(selector = '[data-toggle="tooltip"]') {
        const $selector = $(selector);

        if ($selector.length > 0) {
            if ($.fn.tooltip) {
                $selector.tooltip();
            }
        }

        else {
            import(/* webpackChunkName: "theme/tooltip" */ 'jquery-ui').then(() => {
                $selector.tooltip();
            });
        }
    }

}

export default Tooltip;